import MeetingNotesContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/MeetingNotesContent";
import TeaCornerContent from "./TeaCornerContent";

export default class TeaCornerModel {
    constructor() {
        /** @type {Array<TeaCornerContent>} */
        this._content = [];
    }

    /**
     * Adds coffee corner content
     * @param {TeaCornerContent} content 
     */
    addContent(content) {
        this._content.push(content);
    }

    /**
     * Adds coffee corner content
     * @param {TeaCornerContent} content 
     */
    removeContent(content) {
        const contentIndex = this._content.indexOf(content);
        this._content.splice(contentIndex, 1);
    }

    /**
     * Gets coffee corner content by its inner content (MeetingNotesContent)
     * @param {MeetingNotesContent} innerContent 
     * @returns {TeaCornerContent}
     */
    getContentByInnerContent(innerContent) {
        return this._content.find(c => c.content === innerContent);
    }

    /**
     * Get the current coffee corner content, which is always the latest unlocked content
     * @returns {TeaCornerContent}
     */
    getCurrentContent() {
        return this._content[this._content.length - 1];
    }
}